// extracted by mini-css-extract-plugin
module.exports = {"component":"condensed-table-component--3BIf-"};